// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-authenticate-help-other .LoginHelpContainer {
  padding: 90px 40px 15px;
}
.fi-authenticate-help-other .LoginHelpContainer .support-contact-data-container {
  text-align: start;
  margin-bottom: 20px;
}
.fi-authenticate-help-other .LoginHelpContainer .Ccm-Login-HelpOtherInputContainer .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/authenticate/help-other/help-other.component.scss"],"names":[],"mappings":"AACI;EACI,uBAAA;AAAR;AAEQ;EACI,iBAAA;EACA,mBAAA;AAAZ;AAIY;EACI,WAAA;AAFhB","sourcesContent":[".fi-authenticate-help-other {\r\n    .LoginHelpContainer {\r\n        padding: 90px 40px 15px;\r\n\r\n        .support-contact-data-container {\r\n            text-align: start;\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        .Ccm-Login-HelpOtherInputContainer {\r\n            .mat-mdc-form-field {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
